import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router-dom';
import { useMemo } from 'react';
import { TitleHandle } from '../interfaces/title-handle.interface';
import { useReplaceName } from './use-replace-params.hook';

/**
 * Returns a current page title, based on the route params
 * @example { ...routeDefinition, handle: { title: 'nav.demo' } }
 */
export const usePageTitle = (): string => {
	const [t] = useTranslation();

	const matches = useMatches();

	const getReplaceName = useReplaceName();

	return useMemo(() => {
		const matchWithTitle = matches.find(({ handle }) => !!(handle as TitleHandle)?.title);

		if (!matchWithTitle) {
			return t('nav.root-title') as string;
		}

		const handle = matchWithTitle.handle as TitleHandle;

		const resultTitle = getReplaceName(t(handle.title));

		return resultTitle as string;
	}, [t, matches, getReplaceName]);
};
